import './StickyBottomBanner.scss'
import React from 'react'
import LiveVideo from '../Homepage/LiveVideo'

const StickyBottomBanner = () =>
  <div className="sticky-bottom">
    <LiveVideo />
  </div>

export default StickyBottomBanner
